import CargoCompanyAddressAddRequest from "../../api/raily/cargo-company/address/add/cargo-company-address-add.request";
import CargoCompanyAddressFetchInitDataRequest from "../../api/raily/cargo-company/address/fetch-init-data/cargo-company-address-fetch-init-data.request";
import CargoCompanyAddressUpdateRequest from "../../api/raily/cargo-company/address/update/cargo-company-address-update.request";
import cargoCompanyApiService from "../../api/raily/cargo-company/cargo-company-api.service";
import CargoCompanyAddRequest from "../../api/raily/cargo-company/cargo-company/add/cargo-company-add-request";
import CargoCompanyDetailsRequest from "../../api/raily/cargo-company/cargo-company/details/cargo-company-details.request";
import CargoCompanyListRequest from "../../api/raily/cargo-company/cargo-company/list/cargo-company-list.request";
import CargoCompanyDispatchAddRequest from "../../api/raily/cargo-company/dispatch/add/cargo-company-dispatch-add-request";
import CargoCompanyDispatchDetailsRequest from "../../api/raily/cargo-company/dispatch/details/cargo-company-dispatch-details.request";
import CargoCompanyDispatchListRequest from "../../api/raily/cargo-company/dispatch/list/cargo-company-dispatch-list.request";
import CargoCompanyDispatchMultiListRequest from "../../api/raily/cargo-company/dispatch/multi-list/cargo-company-dispatch-multi-list.request";
import CargoCompanyDispatchUpdateRequest from "../../api/raily/cargo-company/dispatch/update/cargo-company-dispatch-update-request";
import CargoCompanyOrderBillingsDownloadRequest from "../../api/raily/cargo-company/order-billings/download/cargo-company-order-billings-download.request";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import CargoCompanyAddressAddError from "./address/add/cargo-company-address-add-error";
import CargoCompanyAddressAddParams from "./address/add/cargo-company-address-add-params";
import cargoCompanyAddressAddParamsFactory from "./address/add/cargo-company-address-add-params.factory";
import CargoCompanyAddressFetchInitData from "./address/fetch-init-data/cargo-company-address-fetch-init-data";
import CargoCompanyAddressFetchInitDataError from "./address/fetch-init-data/cargo-company-address-fetch-init-data-error";
import CargoCompanyAddressFetchInitDataParams from "./address/fetch-init-data/cargo-company-address-fetch-init-data-params";
import cargoCompanyAddressFetchInitDataParamsFactory from "./address/fetch-init-data/cargo-company-address-fetch-init-data-params.factory";
import cargoCompanyAddressFetchInitDataFactory from "./address/fetch-init-data/cargo-company-address-fetch-init-data.factory";
import CargoCompanyAddressList from "./address/list/cargo-company-address-list";
import CargoCompanyAddressListError from "./address/list/cargo-company-address-list-error";
import CargoCompanyAddressListParams from "./address/list/cargo-company-address-list-params";
import cargoCompanyAddressListParamsFactory from "./address/list/cargo-company-address-list-params.factory";
import cargoCompanyAddressListFactory from "./address/list/cargo-company-address-list.factory";
import CargoCompanyAddressUpdateError from "./address/update/cargo-company-address-update-error";
import CargoCompanyAddressUpdateParams from "./address/update/cargo-company-address-update-params";
import cargoCompanyAddressUpdateParamsFactory from "./address/update/cargo-company-address-update-params.factory";
import CargoCompanyAddError from "./cargo-company/add/cargo-company-add-error";
import CargoCompanyAddParams from "./cargo-company/add/cargo-company-add-params";
import cargoCompanyAddParamsFactory from "./cargo-company/add/cargo-company-add-params.factory";
import CargoCompanyDetails from "./cargo-company/details/cargo-company-details";
import CargoCompanyDetailsError from "./cargo-company/details/cargo-company-details-error";
import CargoCompanyDetailsParams from "./cargo-company/details/cargo-company-details-params";
import cargoCompanyDetailsParamsFactory from "./cargo-company/details/cargo-company-details-params.factory";
import cargoCompanyDetailsFactory from "./cargo-company/details/cargo-company-details.factory";
import CargoCompanyList from "./cargo-company/list/cargo-company-list";
import CargoCompanyListError from "./cargo-company/list/cargo-company-list-error";
import CargoCompanyListParams from "./cargo-company/list/cargo-company-list-params";
import cargoCompanyListParamsFactory from "./cargo-company/list/cargo-company-list-params.factory";
import cargoCompanyListFactory from "./cargo-company/list/cargo-company-list.factory";
import CargoCompanyCargoTaxiContracts from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts";
import CargoCompanyCargoTaxiContractsError from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts-error";
import CargoCompanyCargoTaxiContractsParams from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts-params";
import cargoCompanyCargoTaxiContractsParamsFactory from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts-params.factory";
import cargoCompanyCargoTaxiContractsFactory from "./cargo-taxi/contracts/cargo-company-cargo-taxi-contracts.factory";
import CargoCompanyDispatchAddError from "./dispatch/add/cargo-company-dispatch-add-error";
import CargoCompanyDispatchAddParams from "./dispatch/add/cargo-company-dispatch-add-params";
import cargoCompanyDispatchAddParamsFactory from "./dispatch/add/cargo-company-dispatch-add-params.factory";
import CargoCompanyDispatchDetails from "./dispatch/details/cargo-company-dispatch-details";
import CargoCompanyDispatchDetailsError from "./dispatch/details/cargo-company-dispatch-details-error";
import CargoCompanyDispatchDetailsParams from "./dispatch/details/cargo-company-dispatch-details-params";
import cargoCompanyDispatchDetailsParamsFactory from "./dispatch/details/cargo-company-dispatch-details-params.factory";
import cargoCompanyDispatchDetailsFactory from "./dispatch/details/cargo-company-dispatch-details.factory";
import CargoCompanyDispatchList from "./dispatch/list/cargo-company-dispatch-list";
import CargoCompanyDispatchListError from "./dispatch/list/cargo-company-dispatch-list-error";
import CargoCompanyDispatchListParams from "./dispatch/list/cargo-company-dispatch-list-params";
import cargoCompanyDispatchListParamsFactory from "./dispatch/list/cargo-company-dispatch-list-params.factory";
import cargoCompanyDispatchListFactory from "./dispatch/list/cargo-company-dispatch-list.factory";
import CargoCompanyDispatchMultiList from "./dispatch/multi-list/cargo-company-dispatch-multi-list";
import CargoCompanyDispatchMultiListError from "./dispatch/multi-list/cargo-company-dispatch-multi-list-error";
import CargoCompanyDispatchMultiListParams from "./dispatch/multi-list/cargo-company-dispatch-multi-list-params";
import cargoCompanyDispatchMultiListParamsFactory from "./dispatch/multi-list/cargo-company-dispatch-multi-list-params.factory";
import cargoCompanyDispatchMultiListFactory from "./dispatch/multi-list/cargo-company-dispatch-multi-list.factory";
import CargoCompanyDispatchUpdateError from "./dispatch/update/cargo-company-dispatch-update-error";
import CargoCompanyDispatchUpdateParams from "./dispatch/update/cargo-company-dispatch-update-params";
import cargoCompanyDispatchUpdateParamsFactory from "./dispatch/update/cargo-company-dispatch-update-params.factory";
import CargoCompanyDispatcherList from "./dispatcher/list/cargo-company-dispatcher-list";
import CargoCompanyDispatcherListError from "./dispatcher/list/cargo-company-dispatcher-list-error";
import CargoCompanyDispatcherListParams from "./dispatcher/list/cargo-company-dispatcher-list-params";
import cargoCompanyDispatcherListParamsFactory from "./dispatcher/list/cargo-company-dispatcher-list-params.factory";
import cargoCompanyDispatcherListFactory from "./dispatcher/list/cargo-company-dispatcher-list.factory";
import CargoCompanyOrderBillingsDownload from "./order-billings/download/cargo-company-order-billings-download";
import CargoCompanyOrderBillingsDownloadError from "./order-billings/download/cargo-company-order-billings-download-error";
import CargoCompanyOrderBillingsDownloadParams from "./order-billings/download/cargo-company-order-billings-download-params";
import cargoCompanyOrderBillingsDownloadParamsFactory from "./order-billings/download/cargo-company-order-billings-download-params.factory";
import cargoCompanyOrderBillingsDownloadFactory from "./order-billings/download/cargo-company-order-billings-download.factory";
import CargoCompanyOrderBillingsList from "./order-billings/list/cargo-company-order-billings-list";
import CargoCompanyOrderBillingsListError from "./order-billings/list/cargo-company-order-billings-list-error";
import CargoCompanyOrderBillingsListParams from "./order-billings/list/cargo-company-order-billings-list-params";
import cargoCompanyOrderBillingsListParamsFactory from "./order-billings/list/cargo-company-order-billings-list-params.factory";
import cargoCompanyOrderBillingsListFactory from "./order-billings/list/cargo-company-order-billings-list.factory";
import CargoCompanyPassengerList from "./passenger/list/cargo-company-passenger-list";
import CargoCompanyPassengerListError from "./passenger/list/cargo-company-passenger-list-error";
import CargoCompanyPassengerListParams from "./passenger/list/cargo-company-passenger-list-params";
import cargoCompanyPassengerListParamsFactory from "./passenger/list/cargo-company-passenger-list-params.factory";
import cargoCompanyPassengerListFactory from "./passenger/list/cargo-company-passenger-list.factory";

const getPassengerList = async (
  params: CargoCompanyPassengerListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyPassengerList> => {
  const request = cargoCompanyPassengerListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getPassengerList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyPassengerListFactory.createPassengerList(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyPassengerListError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDispatcherList = async (
  params: CargoCompanyDispatcherListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyDispatcherList> => {
  const request = cargoCompanyDispatcherListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getDispatcherList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyDispatcherListFactory.createDispatcherList(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatcherListError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDispatchList = async (
  params: CargoCompanyDispatchListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyDispatchList> => {
  const request: CargoCompanyDispatchListRequest =
    cargoCompanyDispatchListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getDispatchList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyDispatchListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatchListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const dispatchAdd = async (
  params: CargoCompanyDispatchAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoCompanyDispatchAddRequest =
    cargoCompanyDispatchAddParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().dispatchAdd(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatchAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const dispatchUpdate = async (
  params: CargoCompanyDispatchUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoCompanyDispatchUpdateRequest =
    cargoCompanyDispatchUpdateParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().dispatchUpdate(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatchUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDispatchDetails = async (
  params: CargoCompanyDispatchDetailsParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyDispatchDetails> => {
  const request: CargoCompanyDispatchDetailsRequest =
    cargoCompanyDispatchDetailsParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getDispatchDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyDispatchDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatchDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDispatchMultiList = async (
  params: CargoCompanyDispatchMultiListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyDispatchMultiList> => {
  const request: CargoCompanyDispatchMultiListRequest =
    cargoCompanyDispatchMultiListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getDispatchMultiList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyDispatchMultiListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDispatchMultiListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const cargoCompanyAdd = async (
  params: CargoCompanyAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoCompanyAddRequest =
    cargoCompanyAddParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().cargoCompanyAdd(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoCompanyList = async (
  params: CargoCompanyListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyList> => {
  const request: CargoCompanyListRequest =
    cargoCompanyListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getCargoCompanyList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoCompanyList = cargoCompanyListFactory.create(response);

    return cargoCompanyList;
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoCompanyDetails = async (
  params: CargoCompanyDetailsParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyDetails> => {
  const request: CargoCompanyDetailsRequest =
    cargoCompanyDetailsParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getCargoCompanyDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoCompany = cargoCompanyDetailsFactory.create(response.data);

    return cargoCompany;
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getAddressList = async (
  params: CargoCompanyAddressListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyAddressList> => {
  const request = cargoCompanyAddressListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getAddressList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyAddressListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyAddressListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addressAdd = async (
  params: CargoCompanyAddressAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoCompanyAddressAddRequest =
    cargoCompanyAddressAddParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().addressAdd(
      request,
      abortSignal,
    );
    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyAddressAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const fetchCargoTaxiContractsListing = async (
  params: CargoCompanyCargoTaxiContractsParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyCargoTaxiContracts> => {
  const request = cargoCompanyCargoTaxiContractsParamsFactory.create(params);

  try {
    const response =
      await cargoCompanyApiService().fetchCargoTaxiContractsListing(
        request,
        abortSignal,
      );
    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return cargoCompanyCargoTaxiContractsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyCargoTaxiContractsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const fetchInitData = async (
  params: CargoCompanyAddressFetchInitDataParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyAddressFetchInitData> => {
  const request: CargoCompanyAddressFetchInitDataRequest =
    cargoCompanyAddressFetchInitDataParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().fetchInitData(
      request,
      abortSignal,
    );
    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoCompanyAddressFetchInitData =
      cargoCompanyAddressFetchInitDataFactory.create(response);

    return cargoCompanyAddressFetchInitData;
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyAddressFetchInitDataError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addressUpdate = async (
  params: CargoCompanyAddressUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoCompanyAddressUpdateRequest =
    cargoCompanyAddressUpdateParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().addressUpdate(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyAddressUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoOrderBillingsList = async (
  params: CargoCompanyOrderBillingsListParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyOrderBillingsList> => {
  const request = cargoCompanyOrderBillingsListParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().getCargoOrderBillingsList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyOrderBillingsListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyOrderBillingsListError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const fetchReport = async (
  params: CargoCompanyOrderBillingsDownloadParams,
  abortSignal: AbortSignal,
): Promise<CargoCompanyOrderBillingsDownload> => {
  const request: CargoCompanyOrderBillingsDownloadRequest =
    cargoCompanyOrderBillingsDownloadParamsFactory.create(params);

  try {
    const response = await cargoCompanyApiService().fetchReport(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoCompanyOrderBillingsDownloadFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | CargoCompanyOrderBillingsDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const cargoCompanyService = {
  getPassengerList,
  getDispatcherList,
  getDispatchList,
  dispatchAdd,
  dispatchUpdate,
  getDispatchDetails,
  getDispatchMultiList,
  cargoCompanyAdd,
  getCargoCompanyList,
  getCargoCompanyDetails,
  getAddressList,
  addressAdd,
  fetchCargoTaxiContractsListing,
  fetchInitData,
  addressUpdate,
  getCargoOrderBillingsList,
  fetchReport,
};

export default cargoCompanyService;
